module.exports = __webpack_public_path__ + "static/media/_DSC8699_16_9_AR.a9ee22f6.jpg";